export interface IDonorProfileContact {
    id: number,
    fullName: string,
    isCoordinator: boolean,
    isSurgeon: boolean
}